import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from 'react-router-dom';
import routes from '../../common/models/route-constants';
import NotFoundPage from '../../common/pages/NotFoundPage';
import AnimatedAssetsIllustrationsRouter from './AnimatedAssetsIllustrationsRouter';
import AnimatedAssetsIconsRouter from './AnimatedAssetsIconsRouter';

function AnimatedAssetsRouter() {
    let { path } = useRouteMatch();
    return (
        <React.Fragment>
            <Switch>
                <Route exact path={`${path}`}>
                    <Redirect
                        to={`${routes.ANIMATED_ASSETS}/${routes.ILLUSTRATIONS}`}
                    />
                </Route>
                <Route path={`${path}/${routes.ILLUSTRATIONS}`}>
                    <AnimatedAssetsIllustrationsRouter />
                </Route>
                <Route path={`${path}/${routes.ICONS}`}>
                    <AnimatedAssetsIconsRouter />
                </Route>
                <Route path='*'>
                    <NotFoundPage />
                </Route>
            </Switch>
        </React.Fragment>
    );
}

export default AnimatedAssetsRouter;
